import React from "react";
import { Toaster } from "sonner";
import { useI18n } from "@/i18n/I18nProvider";
import { CAMPS_OPEN } from "@/components/camps/campConfig";
import { CampsHero } from "@/components/camps/CampsHero";
import { CampCard } from "@/components/camps/CampCard";
import { TbaCamps } from "@/components/camps/TbaCamps";
import { CampsComingSoon } from "@/components/camps/CampsComingSoon";
import { CampRegistrationForm } from "@/components/camps/CampRegistrationForm";
import { RegistrationSuccess } from "@/components/camps/CampFormParts";
import { useCampRegistration } from "@/components/camps/useCampRegistration";

const RegistrationSection = ({ c, reg }) => (
  <>
    <div className="overline text-[#C4A46A]">{c.registerSectionKicker}</div>
    <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight">{c.registerSectionTitle}</h2>
    <span className="gold-rule mt-6 block" />
    {reg.submitted ? (
      <RegistrationSuccess f={c.form} onAgain={() => reg.setSubmitted(false)} />
    ) : (
      <CampRegistrationForm c={c} reg={reg} />
    )}
  </>
);

export default function SoccerCamps() {
  const { t, lang } = useI18n();
  const c = t.camps;
  const reg = useCampRegistration(c, lang);

  return (
    <>
      <Toaster position="top-center" richColors />
      <CampsHero c={c} />

      <section className="bg-[#F4F0E8]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-24">
          <div className="overline text-[#C4A46A]">{c.confirmedLabel}</div>
          <span className="gold-rule mt-4 block" />
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0F1B2D]/10">
            {c.confirmed.map((camp, i) => (
              <CampCard key={camp.slug} c={c} camp={camp} index={i} onChoose={reg.chooseCamp} />
            ))}
          </div>
          <TbaCamps c={c} />
        </div>
      </section>

      <section id="camp-registration" className="bg-[#0F1B2D] text-white scroll-mt-28">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
          {CAMPS_OPEN ? <RegistrationSection c={c} reg={reg} /> : <CampsComingSoon c={c} />}
        </div>
      </section>
    </>
  );
}
